import React from "react";
import "./scss/FinancialFundingInfos.scss";

/** COMPONENTS */
import InputValueBlock from "../InputFundingValueBlock/InputFundingValueBlock.component";

interface IProps {
	monthlyIncomes: number | null;
	monthlyIncomesCapacity: number | null;
	mainBorrowerIncomes: number;
	coBorrowerIncomes: number;
	monthlyCredits: number;
	monthlyCreditsCapacity: number;
	personalContribution: number;
	personalContributionCapacity: number;
	CBHandleChange: (event: any) => void;
	CBHandleSubmit: (eventName: string) => void;
}

const FinancialInfos: React.FC<IProps> = ({
	monthlyIncomes,
	monthlyIncomesCapacity,
	mainBorrowerIncomes,
	coBorrowerIncomes,
	monthlyCredits,
	monthlyCreditsCapacity,
	personalContribution,
	personalContributionCapacity,
	CBHandleChange,
	CBHandleSubmit,
}) => {
	return (
		<div className="financial-funding-infos">
			<h2>Mes informations financières</h2>

			<div className="column">
				<InputValueBlock
					iconName="picto-revenus"
					name="monthlyIncomes"
					modalNames={["mainBorrowerIncomes", "coBorrowerIncomes"]}
					label="revenus"
					value={monthlyIncomesCapacity}
					modalValues={[mainBorrowerIncomes, coBorrowerIncomes]}
					CBHandleChange={CBHandleChange}
					CBHandleSubmit={CBHandleSubmit}
				/>
				<InputValueBlock
					iconName="picto-credit"
					name="monthlyCredits"
					modalNames={["monthlyCredits"]}
					label="crédit"
					value={monthlyCreditsCapacity}
					modalValues={[monthlyCredits]}
					CBHandleChange={CBHandleChange}
					CBHandleSubmit={CBHandleSubmit}
				/>
				<InputValueBlock
					iconName="picto-apport"
					name="personalContribution"
					modalNames={["personalContribution"]}
					label="apport"
					value={personalContributionCapacity}
					modalValues={[personalContribution]}
					CBHandleChange={CBHandleChange}
					CBHandleSubmit={CBHandleSubmit}
				/>
			</div>
		</div>
	);
};

export default FinancialInfos;
